import { css } from '@linaria/core'
import { theme } from '#styles/themes'

export const dimmed = css`
  color: ${theme.textSoft};
`

export const pulsing = css`
  animation: 1s linear 0s infinite alternate pulse;

  @keyframes pulse {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.33;
    }
  }
`
